export const Range = {
  BASIC: 'basic',
  MID_RANGE: 'mid_range',
  INNOVATION: 'innovation'
};

export const RANGES = Object.values(Range);

export default Range;
